import React, {Component} from 'react';
import SocialHistoryPartial from '../patientPartials/SocialHistoryPartial';

class SocialHistory extends Component {
  render() {
    const { patientId } = this.props;
    return(
        <SocialHistoryPartial patientId={patientId}/>
    );
  }
}

export default SocialHistory;
